jQuery(function ($) {
  var $inputs = $("input[name=cell],input[name=office]");
  $inputs.on("input", function () {
    // Set the required property of the other input to false if this input is not empty.
    $inputs.not(this).prop("required", !$(this).val().length);
  });
  $("button.submitter").on("click", function (e) {
    e.preventDefault();
    var color = "#413B3D";
    var begin =
      '<!DOCTYPE html><html lang="en"><head><meta http-0equiv="Content-Type" content="text/html; charset=utf-8"><style>@media screen {@font-face {font-family: "Helvetica", "Arial", sans-serif;font-style: normal;font-weight: 300;src: local("Helvetica");}}@media screen and (max-width: 525px) {table[class="responsive-table"] {width: 100% !important;}}h2 {font-size: 14px;color: #413B3D;}h3 {color: ' +
      color +
      ';font-size: 12px;}p {color: #413B3D;font-size: 10px;}a {color: #4d4d4d;text-decoration: none;}</style></head><body style="margin: 0; padding: 0;">';
    $("#signature").text(
      begin + $("#signature-preview").html() + "</" + "bo" + "dy></html>"
    );
    //$('#generated').show();
    var w = window.open();
    var html = $("#signature").text();
    $(w.document.body).html(html);
  });
});

function selectCompany(el) {
  jQuery(".signature-preview").hide();
  jQuery("#" + jQuery(el).val() + "-preview").show();
  jQuery(".signature-preview h3").css("color", jQuery(el).attr("data-color"));
}

function updatePreview() {
  var color = jQuery("#form-input-company option:selected").data("color");
  jQuery(".the-name").html(jQuery("#form-input-name").val());
  jQuery(".the-title").html(jQuery("#form-input-title").val());
  jQuery(".the-address").html(jQuery("#form-input-address").val());
  jQuery(".the-city-state-zip").html(
    jQuery("#form-input-city").val() +
      ", " +
      jQuery("#form-input-state").val() +
      " " +
      jQuery("#form-input-zip").val()
  );
  if (
    jQuery("#form-input-cell").val() != "" &&
    jQuery("#form-input-office").val() != ""
  ) {
    jQuery(".the-phones").html(
      '<span style="color: ' +
        color +
        '; font-weight: bold;">O:</span> <a href="tel:' +
        jQuery("#form-input-office").cleanVal() +
        '" style="color: #413B3D; text-decoration: none;">' +
        jQuery("#form-input-office").val() +
        '</a> <span style="color: ' +
        color +
        '; font-weight: bold;">|</span> <span style="color: ' +
        color +
        '; font-weight: bold;">C:</span> <a href="tel:' +
        jQuery("#form-input-cell").cleanVal() +
        '" style="color: #4d4d4d; text-decoration: none;">' +
        jQuery("#form-input-cell").val() +
        "</a><br>"
    );
  }
  if (
    jQuery("#form-input-cell").val() == "" &&
    jQuery("#form-input-office").val() != ""
  ) {
    jQuery(".the-phones").html(
      '<span style="color: ' +
        color +
        '; font-weight: bold;">O:</span> <a href="tel:' +
        jQuery("#form-input-office").cleanVal() +
        '" style="color: #413B3D; text-decoration: none;">' +
        jQuery("#form-input-office").val() +
        "</a><br>"
    );
  }
  if (
    jQuery("#form-input-cell").val() != "" &&
    jQuery("#form-input-office").val() == ""
  ) {
    jQuery(".the-phones").html(
      '<span style="color: ' +
        color +
        '; font-weight: bold;">C:</span> <a href="tel:' +
        jQuery("#form-input-cell").cleanVal() +
        '" style="color: #413B3D; text-decoration: none;">' +
        jQuery("#form-input-cell").val() +
        "</a><br>"
    );
  }
  if (
    jQuery("#form-input-cell").val() == "" &&
    jQuery("#form-input-office").val() == ""
  ) {
    jQuery(".the-phones").html("");
  }
}
